module.exports = {
    headers: {
        accept: 'application/json'
    },
    baseUrl: 'https://api.appgestorrp.com.br/api/'
    //baseUrl: 'https://5289-177-137-253-157.ngrok.io/api/'
    //baseUrl: 'https://e3fc82dd76d8.ngrok-free.app/api/'
    //baseUrl: 'http://localhost:8080/api/'
}
